import React from 'react';
import { Checkbox, withStyles, FormControlLabel } from '@material-ui/core';
import { decorate, observable } from 'mobx';
import { observer } from 'mobx-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import ErrorAlert from '~/Components/ErrorAlert';
import { ActionButton, FormBuilder } from '~/Components/From';
import { asEntity } from '~/Hoc';
import { loadLocalStorageDataForm, storeInLocalStorage } from '~/Components/From/FormControl/Visitor';
import { formDependency, getFormikProps, formData } from './data';
import useStyles from './styles';
import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module';
import { getWink34GA, isEmpty } from '~/Services/Helpers';
import { processFormFields, createFormData, handleSubmit } from '../../../PatientFormUtils';

class RegisterForm extends React.Component {
  editValues = { gender: 0 };
  promotionsAgreement = false;
  promotionsAgreementChecked = false;
  showTermsOfUse = false;
  showPrivacyPolicy = false;
  isSubmitted = false;
  countryDisabled = false;
  isSepecsavers = false;
  formikProps = null;

  state = {
    shouldRender: false,
  };

  componentWillMount() {
    const { userContextObj } = this.props;
    const { themename } = userContextObj;
    this.isSepecsavers = themename && themename === 'Specsavers';
    localStorage.setItem('booking_stage', 'personal_details');

    ReactGA.event({
      event: 'page_view',
      vPath: `/book/${localStorage.getItem('store')}/new-user`,
      territory: 'en_CA',
      store_type: 'optics',
      booking_stage: 'personal_details',
      sas_type: 'wink',
      content_id: '/wink/book',
      store_name: localStorage.getItem('store'),
      view_state: !isEmpty(userContextObj.lastBooking) ? 'change' : 'main',
      booking_type: localStorage.getItem('ga_booking_type'),
      dpdItem: 'wink-7',
    });

    TagManager.dataLayer({
      dataLayer: {
        event: 'page_view',
        vPath: `/book/${localStorage.getItem('store')}/new-user`,
        territory: 'en_CA',
        store_type: 'optics',
        booking_stage: 'personal_details',
        sas_type: 'wink',
        content_id: '/wink/book',
        store_name: localStorage.getItem('store'),
        view_state: !isEmpty(userContextObj.lastBooking) ? 'change' : 'main',
        booking_type: localStorage.getItem('ga_booking_type'),
        dpdItem: 'wink-7',
      },
    });
    this.setState({ shouldRender: false });
    this.props.entityStore.get({ accountId: `${userContextObj.accountId}`, accountName: `${userContextObj.accountName}` });
    this.editValues = { gender: 0, ...loadLocalStorageDataForm('RegisterForm'), preferredContactMethod: 'email', };
  }

  sendGAEventOnSubmit = (values) => {
    const { userContextObj } = this.props;
    const { lastBooking } = userContextObj;
    const wink34GA = getWink34GA(lastBooking, 'register');

    ReactGA.event(wink34GA);

    TagManager.dataLayer({
      dataLayer: wink34GA,
    });
  };

  handleSubmit = (values) => {
    const result = handleSubmit(
      {
        ...values,
        ...(values.cell && { cell: values.cell.replace(/^\+1/, '') }),
        ...(values.phone && { phone: values.phone.replace(/^\+1/, '') }),
        ...(this.promotionsAgreement && { promotionsAgreement: this.promotionsAgreementChecked }),
      },
      this.props,
      this.props.entityStore,
      this.fieldToHide,
      { forceCreatePatient: false, password: values.password }
    );

    if (result.error) {
      this.errorMessage = result.error;
      this.error = true;
    } else {
      Object.assign(this, result);
    }

    this.sendGAEventOnSubmit(values);
  };

  entityDidPosted(data) {
    this.loading = false;
    const {
      userContextObj: { accountId, accountName },
    } = this.props;

    this.props.setUserContext({
      email: this.values.email,
      cell: this.values.cell,
      newUserValues: { ...this.values },
    });
    this.props.setValue(4);
  }

  entityDidReceived(data) {
    if (data) {
      this.promotionsAgreement = !data.hidePromotionsAgreement;
      const { fieldToHide, processedNonRequiredFields } = processFormFields(data);
      this.fieldToHide = fieldToHide;
      this.nonRequiredFields = processedNonRequiredFields;
      this.countryDisabled = data.hideAddressField;

      const { userContextObj } = this.props;
      this.formikProps = getFormikProps(this.nonRequiredFields);
      this.formData = formData(`Country/list?accountsId=${userContextObj.accountId}`, `Patient/gender/list`, this.nonRequiredFields, this.fieldToHide, this.props.intl);

      this.setState({ shouldRender: true });
    }
  }

  entityDidCatch(error) {
    if (error?.patientloginExist) {
      storeInLocalStorage('RegisterForm', this.values);
      this.props.setMessage('patientAlreadyExist');
      this.props.setValue(1);
    } else {
      if (error.message === 'InvalidPassword') {
        this.errorMessage = 'invalidPassword';
        this.error = true;
      }
    }

    this.loading = false;
  }

  store = (values) => {
    storeInLocalStorage('RegisterForm', values);
  };

  changePromotionsAgreementChecked = () => (this.promotionsAgreementChecked = !this.promotionsAgreementChecked);

  render() {
    const { classes } = this.props;
    const fieldsToHide = JSON.parse(localStorage.getItem('fieldsToHide'));
    let hideMessageAndDataRate = !!fieldsToHide && fieldsToHide?.hideMessageAndDataRate;
    let hideContactInAdvanceText = !!fieldsToHide && fieldsToHide?.hideContactInAdvanceText;
    const { shouldRender } = this.state;

    return (
      <div>
        {this.error && this.errorMessage && <ErrorAlert messageId={this.errorMessage} />}
        {shouldRender && (
          <div className={classes.FormWrapper}>
            <FormBuilder
              {...this.formikProps}
              formData={this.formData}
              formName='RegisterForm'
              formDependency={!this.countryDisabled ? formDependency : {}}
              saveInLocalStorage={this.store}
              editValues={this.editValues}
              submitAction={this.handleSubmit}
              customStyle={{ flexBasis: '100%' }}
              trackFirstInteraction={true}
            >
              {this.promotionsAgreement && (
                <div className={classes.promoAndNoteContainer}>
                  <div className={classes.promotionsAgreeContainer}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.promotionsAgreementChecked}
                          onChange={this.changePromotionsAgreementChecked}
                          inputProps={{ 'aria-describedby': 'promotions-terms-desc' }}
                          color='primary'
                        />
                      }
                      label={<FormattedMessage id={'promotionsAgreement'} />}
                    />
                  </div>
                </div>
              )}

              {!this.isSepecsavers && (
                <div className={classes.promoAndNoteContainer}>
                  <p className={classes.notes}>
                    {!hideMessageAndDataRate && (
                      <span style={{ display: 'block' }}>
                        <FormattedMessage id={'messageApply'} />
                      </span>
                    )}
                    {!hideContactInAdvanceText && (
                      <span style={{ display: 'block' }}>
                        <FormattedMessage id={'contact'} />
                      </span>
                    )}
                  </p>
                </div>
              )}
              <div className={classes.actionsWrapper}>
                <ActionButton
                  customClass={classes.SubmitButton}
                  title={'Next'}
                  icon={'person_add'}
                  variant='contained'
                  loading={this.loading}
                />
              </div>
            </FormBuilder>
          </div>
        )}
      </div>
    );
  }
}

decorate(RegisterForm, {
  loading: observable,
  error: observable,
  promotionsAgreement: observable,
  editValues: observable,
  showTermsOfUse: observable,
  showPrivacyPolicy: observable,
  values: observable,
  isSubmitted: observable,
  promotionsAgreementChecked: observable,
  errorMessage: observable,
  isSepecsavers: observable,
  countryDisabled: observable,
});

export default injectIntl(withStyles(useStyles)(asEntity({ storeId: 'RegisterForm' })(observer(RegisterForm))));
